import React, { useState } from 'react';
import '../css/Analytics.css';

const Analytics = () => {
  const [selectedPeriod, setSelectedPeriod] = useState('7d');

  const metrics = [
    {
      title: 'Total Users',
      value: '12,847',
      change: '+12.5%',
      changeType: 'positive',
      icon: '👥'
    },
    {
      title: 'Active Sessions',
      value: '2,341',
      change: '+8.2%',
      changeType: 'positive',
      icon: '🟢'
    },
    {
      title: 'Page Views',
      value: '89,234',
      change: '-2.1%',
      changeType: 'negative',
      icon: '👁️'
    },
    {
      title: 'Conversion Rate',
      value: '3.2%',
      change: '+1.8%',
      changeType: 'positive',
      icon: '📈'
    }
  ];

  const chartData = [
    { day: 'Mon', users: 1200, sessions: 800, views: 5000 },
    { day: 'Tue', users: 1350, sessions: 950, views: 6200 },
    { day: 'Wed', users: 1100, sessions: 750, views: 4800 },
    { day: 'Thu', users: 1600, sessions: 1100, views: 7200 },
    { day: 'Fri', users: 1400, sessions: 900, views: 5800 },
    { day: 'Sat', users: 900, sessions: 600, views: 3800 },
    { day: 'Sun', users: 800, sessions: 500, views: 3200 }
  ];

  const topPages = [
    { page: '/dashboard', views: 15420, change: '+12%' },
    { page: '/users', views: 12340, change: '+8%' },
    { page: '/analytics', views: 9870, change: '+15%' },
    { page: '/reports', views: 7650, change: '+5%' },
    { page: '/settings', views: 5430, change: '+3%' }
  ];

  return (
    <div className="analytics-content">
      <div className="page-header">
        <div className="header-content">
          <h1>Analytics Dashboard</h1>
          <p>Monitor your application performance and user behavior</p>
        </div>
        <div className="period-selector">
          <select 
            value={selectedPeriod} 
            onChange={(e) => setSelectedPeriod(e.target.value)}
          >
            <option value="7d">Last 7 days</option>
            <option value="30d">Last 30 days</option>
            <option value="90d">Last 90 days</option>
            <option value="1y">Last year</option>
          </select>
        </div>
      </div>

      <div className="metrics-grid">
        {metrics.map((metric, index) => (
          <div key={index} className="metric-card">
            <div className="metric-header">
              <div className="metric-icon">{metric.icon}</div>
              <div className="metric-change">
                <span className={`change-indicator ${metric.changeType}`}>
                  {metric.change}
                </span>
              </div>
            </div>
            <div className="metric-content">
              <h3 className="metric-value">{metric.value}</h3>
              <p className="metric-title">{metric.title}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="charts-section">
        <div className="chart-container">
          <div className="chart-header">
            <h2>Traffic Overview</h2>
            <p>User activity over the selected period</p>
          </div>
          <div className="chart-content">
            <div className="chart-legend">
              <div className="legend-item">
                <div className="legend-color users"></div>
                <span>Users</span>
              </div>
              <div className="legend-item">
                <div className="legend-color sessions"></div>
                <span>Sessions</span>
              </div>
              <div className="legend-item">
                <div className="legend-color views"></div>
                <span>Page Views</span>
              </div>
            </div>
            <div className="chart-bars">
              {chartData.map((data, index) => (
                <div key={index} className="chart-bar-group">
                  <div className="bar-label">{data.day}</div>
                  <div className="bars">
                    <div 
                      className="bar users" 
                      style={{ height: `${(data.users / 1600) * 100}%` }}
                    ></div>
                    <div 
                      className="bar sessions" 
                      style={{ height: `${(data.sessions / 1100) * 100}%` }}
                    ></div>
                    <div 
                      className="bar views" 
                      style={{ height: `${(data.views / 7200) * 100}%` }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="analytics-grid">
        <div className="top-pages-card">
          <h2>Top Pages</h2>
          <div className="pages-list">
            {topPages.map((page, index) => (
              <div key={index} className="page-item">
                <div className="page-info">
                  <span className="page-name">{page.page}</span>
                  <span className="page-views">{page.views.toLocaleString()} views</span>
                </div>
                <span className="page-change positive">{page.change}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="user-demographics-card">
          <h2>User Demographics</h2>
          <div className="demographics-content">
            <div className="demographic-item">
              <div className="demographic-label">Age Groups</div>
              <div className="demographic-bars">
                <div className="demographic-bar">
                  <span>18-24</span>
                  <div className="bar-fill" style={{ width: '25%' }}></div>
                  <span>25%</span>
                </div>
                <div className="demographic-bar">
                  <span>25-34</span>
                  <div className="bar-fill" style={{ width: '40%' }}></div>
                  <span>40%</span>
                </div>
                <div className="demographic-bar">
                  <span>35-44</span>
                  <div className="bar-fill" style={{ width: '20%' }}></div>
                  <span>20%</span>
                </div>
                <div className="demographic-bar">
                  <span>45+</span>
                  <div className="bar-fill" style={{ width: '15%' }}></div>
                  <span>15%</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Analytics; 